import {NgIf} from '@angular/common';
import {CommonModule} from '@angular/common';
import {AfterViewInit, OnChanges, OnInit} from '@angular/core';
import {Component, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {finalize, tap} from "rxjs";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatFormFieldModule, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {ChangeDetectorRef} from '@angular/core';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {CookieService} from "ngx-cookie-service";
import { MatAccordion, MatExpansionModule, MatExpansionPanel, MatExpansionPanelDescription, MatExpansionPanelTitle} from "@angular/material/expansion";
import { environment } from '../../../../environments/environment';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { AnalyseService } from '../../../services/analyse-service/analyse.service';
import { HandleErrorsService } from '../../../services/handle-erros/handle.errors.service';
import { ParametreService } from '../../../services/parametre-service/parametre.service';
import { SampleStatusService } from '../../../services/sample-status-service/sample.status.service';
import { TerrrainService } from '../../../services/terrains-service/terrrain.service';
import { TypeAnalyseService } from '../../../services/type-analyse-service/type.analyse.service';
import { DialogService } from '../../_modal/dialog.service';
import { ApiService } from '../../_services/api.service';
import { Endpoints } from '../../endpoints';
import { MatChipsModule } from '@angular/material/chips';
import { ParameterDTO } from '../../_models/ParameterDTO';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { formuleDTO } from '../../_models/formuleDTO';
import {MatAutocompleteModule, MatOption} from "@angular/material/autocomplete";
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSelect } from '@angular/material/select';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { PesticideData } from '../../_models/ProductPesticideMRL';
import { PesticideService } from '../../../services/pest-service/pest.service';
import { MatRadioModule } from '@angular/material/radio';



@Component({
    selector: 'app-manage-matrice',
    standalone: true,
    providers: [TerrrainService,AnalyseService, ParametreService, TypeAnalyseService, ApiService, Endpoints, DialogService, HandleErrorsService, SampleStatusService],
    imports: [MatExpansionModule,MatRadioModule,
    MatNativeDateModule,
    CommonModule,MatOption,MatExpansionModule,
    MatNativeDateModule,
    CommonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
    MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput,
    MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, MatDatepickerToggle, MatDatepicker, MatDatepickerInput, MatCheckbox, MatProgressSpinner, MatTab, MatTabGroup, MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionPanelDescription,
    MatCardModule, MatMenuModule, MatButtonModule,MatButtonToggleModule, MatTableModule, MatPaginatorModule, NgIf,
    MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput,MatChipsModule,MatSlideToggleModule,
    MatSuffix, MatSortModule, MatInputModule, MatDatepickerToggle,MatDatepicker, MatDatepickerInput, MatCheckbox],
   templateUrl: './manage-parameter.component.html',
  styleUrl: './manage-parameter.component.scss'
})

export class ManageParameterComponent  implements OnInit, OnChanges, AfterViewInit {

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    form: FormGroup;
    searchVal: string = ''
    dataSource: MatTableDataSource<ParameterDTO> = new MatTableDataSource<ParameterDTO>();
    selectedMatrices: Set<ParameterDTO> = new Set<ParameterDTO>();
    isAllParameterSelected: boolean = false
    pesticideControl = new FormControl<number | null>(null, Validators.required);
    filteredPesticides: PesticideData[] = [];

    allPesticides: PesticideData[] = [];
    displayedColumns: string[] = [
        //'id',
        'codeParameter',
        'paramName',
        'sumVariants',
        'uniteRap',
        'abbreviation',
        'norme',
        'description',
        'met',
        'duree',
        //'arabicName',
        'sousTraite',
       // 'departementId',
        'unite',
        'niveauSouhaitablemin',
        'niveauSouhaitablemax',
        'mri',
         // 'qc',
        'technique',
        'nomFamille',
        'creationDate',
        'updateDate',
        'createdBy',
        'formule',
        //'casNumber'

    ];
    autocompleteActivated = false;
columnLabels: Record<string, string> = {
  codeParameter: 'Code paramètre',
  paramName: 'Nom du paramètre',
  sumVariants: 'Variantes',
  uniteRap: 'Nom rapport',
  abbreviation: 'Abréviation',
  norme: 'Norme',
  description: 'Description',
  met: 'Méthode',
  duree: 'Durée',
  sousTraite: 'Sous-traité',
  unite: 'Unité',
  niveauSouhaitablemin: 'Niveau min',
  niveauSouhaitablemax: 'Niveau max',
  mri: 'MRI',
  technique: 'Technique',
  nomFamille: 'Famille',
  creationDate: 'Date création',
  updateDate: 'Dernière MAJ',
  createdBy: 'Créé par',
  formule: 'Formule',
};
    onInputFocus() {
    this.autocompleteActivated = true;
        console.log("Champ focus, activation de l'autocomplete");

    }

    columns: string[] = [...this.displayedColumns];
    content: any;
    loadingTable: boolean = true;
    loadingOT: boolean = false
    loadingPdfGen: boolean = false
    loadingRapport: boolean = false
    loadingExcel: boolean = false
    panelOpenState = false;
    creatingParameter = false;
    formuleList:formuleDTO[] = []
    toastr: any;
    selectedNomFamille: string = '';


    ngOnInit() {
    this.fetchSampleList();
    this.getColsCookie();
    this.fetchFormuletList();

    // Initialiser le champ pesticide et son filtrage
this.pesticideService.getAll().subscribe(pesticides => {

    console.log("✅ Pesticides reçus depuis l'API :", pesticides);

    this.allPesticides = pesticides;
    this.filteredPesticides = pesticides;

    console.log("📦 Nombre total de pesticides :", this.allPesticides.length);

    this.pesticideControl.valueChanges.subscribe((value: any) => {

        console.log("⌨️ Valeur tapée dans le champ :", value);

        const filterValue = typeof value === 'string' ? value.toLowerCase() : '';

        console.log("🔎 Valeur utilisée pour le filtre :", filterValue);

        this.filteredPesticides = this.allPesticides.filter(p => {
            const match = p.pesticideResidueName.toLowerCase().includes(filterValue);

            if (match) {
                console.log("✔️ Match trouvé :", p.pesticideResidueName);
            }

            return match;
        });

        console.log("📋 Résultat filtré :", this.filteredPesticides);
        console.log("📊 Nombre de résultats :", this.filteredPesticides.length);

    });

});

    // Réagir au changement du champ nomFamille
    this.form.get('nomFamille')?.valueChanges.subscribe(value => {
        this.selectedNomFamille = value?.toUpperCase() || '';

        if (this.selectedNomFamille === 'PESTICIDE') {
        this.form.get('name')?.clearValidators();
        this.form.get('name')?.updateValueAndValidity();
        this.form.get('name')?.disable();

        this.pesticideControl.setValidators([Validators.required]);
        this.pesticideControl.updateValueAndValidity();

        // Pas besoin de fetchPesticides() ici, déjà fait dans getAll() plus haut
        } else {
        this.form.get('name')?.setValidators([Validators.required]);
        this.form.get('name')?.enable();
        this.form.get('name')?.updateValueAndValidity();

        this.pesticideControl.clearValidators();
        this.pesticideControl.updateValueAndValidity();
        }
    });
    
    }

    displayPesticideName(pesticideId: any): string {
    if (!pesticideId) return '';
    
    const pesticide = this.allPesticides.find(
        p => p.id === +pesticideId // + pour convertir en nombre si besoin
    );
    
    return pesticide ? pesticide.pesticideResidueName : '';
    }


// Pour récupérer l'id sélectionné et l'utiliser dans ton objet à envoyer
    getSelectedPesticideId(): number | null {
    return this.pesticideControl.value || null;
    }
        constructor(
        private cookieService: CookieService,
        private pesticideService:PesticideService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private cdr: ChangeDetectorRef,
        private overlayContainer: OverlayContainer,
        private parameterService: ParametreService,
        private handleErrors: HandleErrorsService) {
        this.initializeForm();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['dataSource']) {
            this.initializeForm();
        }
    }

 initializeForm() {
    this.form = this.fb.group({
        id: [''],
        codeParameter: ['', Validators.required],
        sumVariants: [false],
        paramName: [''],  // Nom complet du paramètre (pour molécules libres)
        pesticideId: [''],
        pesticide: this.fb.group({          // ✅ Sous-formulaire pour le pesticide
            id: [''],
            pesticideResidueId: [''],
            pesticideResidueName: ['']
        }),
        abbreviation: [''],
        norme: [''],
        description: [''],
        met: [''],
        duree: [''],
        arabicName: [''],
        sousTraite: [false],
        unite: [''],
        uniteRap: [''],
        niveauSouhaitablemin: [''],
        niveauSouhaitablemax: [''],
        mri: [''],
          //qc: [''],
        technique: [''],
        nomFamille: [''],
        creationDate: [new Date()],
        updateDate: [''],
        formuleText: [''],       // Pour afficher la formule
        createdByName: [''],     // Pour afficher le nom du créateur
        createdBy: [null],   // Affichage "Créé par"
        formule: [null],     // Affichage "Formule"
        // casNumber: [null, Validators.required],
    });
}


    
    getFormuleName(id: number): string {
        const type = this.formuleList.find(t => t.id === id);
        return type ? type.formule : 'Inconnu';
      }

      private fetchFormuletList() {
        this.parameterService.getAllFormules().subscribe({
                next: response => response.status ? this.formuleList = response.data : null,
            }
        );
    }

    
    ngAfterViewInit() {
        this.initializePaginatorAndSort()
    }

    initializePaginatorAndSort() {
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
        this.dataSource.filter = this.searchVal
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'desc';

    }
editParameter(parameter: any) {
    console.log("=== Début editParameter ===");
    console.log("Parameter reçu :", parameter);

    // 1️⃣ Patch des champs simples
    this.form.patchValue({
        id: parameter.id || null,
        codeParameter: parameter.codeParameter || '',
        sumVariants: parameter.sumVariants || '',
        paramName: parameter.paramName || '',
        abbreviation: parameter.abbreviation || '',
        norme: parameter.norme || '',
        description: parameter.description || '',
        met: parameter.met || '',
        duree: parameter.duree || '',
        arabicName: parameter.arabicName || '',
        sousTraite: parameter.sousTraite ?? false,
        unite: parameter.unite || '',
        uniteRap: parameter.uniteRap || '',
        niveauSouhaitablemin: parameter.niveauSouhaitablemin ?? null,
        niveauSouhaitablemax: parameter.niveauSouhaitablemax ?? null,
        mri: parameter.mri ?? null,
        //  qc: parameter.qc ?? null,
        technique: parameter.technique || '',
        nomFamille: parameter.nomFamille || '',
        creationDate: parameter.creationDate ? new Date(parameter.creationDate) : null,
        updateDate: parameter.updateDate ? new Date(parameter.updateDate) : null,
        pesticideId: null, // reset initial
        createdBy: parameter.createdByName || 'N/A',
        formule: null // reset formule initial
    });

    console.log("Formulaire après patch des champs simples :", this.form.value);

    // 2️⃣ Patch formule
    if (parameter.formuleText) {
        const formuleObj = this.formuleList.find(f => f.formule === parameter.formuleText);
        console.log("formule trouvée :", formuleObj);
        this.form.get('formule')?.setValue(formuleObj ? formuleObj.formule : parameter.formuleText);
    } else {
        this.form.get('formule')?.setValue(null);
    }

    console.log("Formulaire après patch formule :", this.form.value);

    // 3️⃣ Patch pesticide si nomFamille === 'PESTICIDE'
    if (parameter.nomFamille === 'PESTICIDE' && parameter.pesticideId) {
        // Chercher le pesticide dans la liste filtrée
        const pesticideObj = this.filteredPesticides.find(p => p.id === parameter.pesticideId || p.pesticideResidueId === parameter.pesticideId);
        console.log("pesticide trouvé :", pesticideObj);

        this.form.get('pesticide')?.patchValue({
            id: pesticideObj?.id || '',
            pesticideResidueId: pesticideObj?.pesticideResidueId || '',
            pesticideResidueName: pesticideObj?.pesticideResidueName || ''
        });

        // Mettre à jour le control de l'autocomplete
        this.pesticideControl.setValue(pesticideObj?.id || null);
        this.form.get('pesticideId')?.setValue(pesticideObj?.id || null);
    } else {
        // Cas molécule libre ou pesticide non trouvé
        this.form.get('pesticide')?.patchValue({
            id: '',
            pesticideResidueId: '',
            pesticideResidueName: ''
        });
        this.pesticideControl.setValue(null);
        this.form.get('pesticideId')?.setValue(null);
    }

    console.log("Formulaire après patch pesticide :", this.form.value);

    // 4️⃣ Debug final : check des controls
    console.log("Form controls :", this.form.controls);
    console.log("Form pesticide group :", this.form.get('pesticide')?.value);

    // 5️⃣ Ouvrir la modal
    this.modalService.open(this.editModal, { size: 'lg' });
    console.log("=== Fin editParameter ===");
}



    casNumber: string = '';
    parameterInfo: any; // Contiendra les informations récupérées
    testCasNumber(casNumber: string) {
        console.log('CasNumber:', casNumber);  // Vérification du casNumber
        this.parameterService.getParameterByCasNumber(casNumber).subscribe(
          (data) => {
            console.log('Données reçues de l\'API :', data);  // Affiche les données complètes de l'API
            if (data) {
              this.parameterInfo = data; // Assurez-vous que data contient des informations valides
              console.log('Données récupérées :', data);
              this.form.patchValue({
                casNumber: data.casNumber,
              });
            } else {
              this.parameterInfo = null; // Si aucune donnée n'est trouvée
              console.log('Aucune donnée trouvée pour ce Cas Number');
            }
          },
          (error) => {
            console.error('Erreur lors de la récupération des données :', error);
          }
        );
      }
      
saveUpdatedParameter() {
    console.log("Formulaire de mise à jour soumis :", this.form.value);

    if (this.form.invalid) {
        console.error("Le formulaire est invalide", this.form.errors);
        Object.keys(this.form.controls).forEach(key => {
            const controlErrors = this.form.get(key)?.errors;
            if (controlErrors) {
                console.warn(`Erreur dans le champ '${key}':`, controlErrors);
            }
        });
        return;
    }

    const currentUserIdStr = sessionStorage.getItem('user_id');
    if (!currentUserIdStr) {
        console.error("Utilisateur non trouvé dans la session.");
        return;
    }
    const currentUserId = Number(currentUserIdStr);

    // 🔹 Récupérer la formule sélectionnée ou libre
    let formuleId: number | null = null;
    let formuleText: string | null = null;
    if (this.form.value.formule) {
        const selectedFormule = this.formuleList.find(f => f.formule === this.form.value.formule);
        if (selectedFormule) {
            formuleId = selectedFormule.id;       // ✅ ID si existant
            formuleText = selectedFormule.formule;
        } else {
            formuleId = null;                     // ✅ ID = null si formule libre
            formuleText = this.form.value.formule;
        }
    }

    // 🔹 Créer le DTO avec pesticide si applicable
    const parameterDTO: any = {
        id: this.form.value.id,
        codeParameter: this.form.value.codeParameter,
        sumVariants: this.form.value.sumVariants,
        name: this.form.value.paramName || this.form.value.codeParameter,
        abbreviation: this.form.value.abbreviation || '',
        norme: this.form.value.norme || '',
        description: this.form.value.description || '',
        met: this.form.value.met || '',
        duree: this.form.value.duree || '',
        arabicName: this.form.value.arabicName || '',
        soucheControle: this.form.value.soucheControle || '',
        sousTraite: this.form.value.sousTraite ?? false,
        departementId: this.form.value.departementId || 0,
        unite: this.form.value.unite || '',
        uniteRap: this.form.value.uniteRap || '',
        niveauSouhaitablemin: this.form.value.niveauSouhaitablemin ?? 0,
        niveauSouhaitablemax: this.form.value.niveauSouhaitablemax ?? 0,
        mri: this.form.value.mri ?? 0,
          //qc: this.form.value.qc ?? 0,
        method: this.form.value.method || '',
        technique: this.form.value.technique || '',
        nomFamille: this.form.value.nomFamille || '',
        creationDate: this.form.value.creationDate || new Date().toISOString().split('T')[0],
        updateDate: new Date().toISOString().split('T')[0],
        createdById: currentUserId,
        formuleId: formuleId,           // ✅ ID ou null
        formuleText: formuleText ?? '', // ✅ texte libre
        casNumber: this.form.value.casNumber || '',
        pesticideId: null,
        pesticideName: null
    };

    // 🔹 Gestion du pesticide si c'est un parameter de type PESTICIDE
    if (this.form.value.nomFamille === 'PESTICIDE') {
        const selectedPesticide = this.allPesticides.find(
            p => p.id === this.pesticideControl.value
        );
        if (!selectedPesticide) {
            console.error("❌ Pesticide sélectionné non trouvé.");
            return;
        }
        parameterDTO.pesticideId = selectedPesticide.id;
        parameterDTO.pesticideName = selectedPesticide.pesticideResidueName;
        console.log("✅ Pesticide associé ID:", parameterDTO.pesticideId);
    } else {
        console.log("✅ Cas molécule libre, pas de pesticide");
    }

    console.log("ParameterDTO à envoyer :", parameterDTO);

    // 🔹 Appel au backend
    this.parameterService.updateParameter(parameterDTO.id, parameterDTO).subscribe({
        next: (response) => {
            console.log("Mise à jour réussie :", response);
            if (response.status) {
                this.modalService.dismissAll();
                this.cdr.detectChanges();
                this.fetchSampleList();
            } else {
                console.error("Échec de la mise à jour :", response.message);
            }
        },
        error: (error) => {
            console.error("Erreur lors de la mise à jour du paramètre :", error);
        }
    });
}

    openEditModal(parameter: any) {
    console.log("Parameter sélectionnée :", parameter);

    // 1️⃣ Patch des champs simples du formulaire
    this.form.patchValue({
        id: parameter.id || null,
        codeParameter: parameter.codeParameter || '',
        paramName: parameter.paramName || '',
        abbreviation: parameter.abbreviation || '',
        nomFamille: parameter.nomFamille || '',
        technique: parameter.technique || '',
        sumVariants: parameter.sumVariants || '',
        met: parameter.met || '',
        unite: parameter.unite || '',
        uniteRap: parameter.uniteRap || '',
        niveauSouhaitablemin: parameter.niveauSouhaitablemin ?? null,
        niveauSouhaitablemax: parameter.niveauSouhaitablemax ?? null,
        mri: parameter.mri ?? null,
         // qc: parameter.qc ?? null,
        description: parameter.description || '',
        duree: parameter.duree || '',
        formuleText: parameter.formuleText || '',
        createdByName: parameter.createdByName || (parameter.createdBy?.username ?? 'Non renseigné'),
        creationDate: parameter.creationDate ? new Date(parameter.creationDate) : null,
        updateDate: parameter.updateDate ? new Date(parameter.updateDate) : null,
        casNumber: parameter.casNumber || '',
        pesticideId: null, // reset initial
        pesticide: { id: '', pesticideResidueId: '', pesticideResidueName: '' } // reset initial
    });

    // 2️⃣ Gérer le pesticide si le paramètre est de type PESTICIDE
    if (parameter.nomFamille === 'PESTICIDE' && parameter.pesticideId) {
        // Trouver le pesticide correspondant dans la liste
        const matchedPesticide = this.allPesticides.find(
            p => p.id === parameter.pesticideId
        );

        if (matchedPesticide) {
            // ✅ Patcher le FormControl de l’autocomplete
            this.pesticideControl.setValue(matchedPesticide.id);

            // ✅ Mettre à jour le form group pesticide et pesticideId
            this.form.patchValue({
                pesticideId: matchedPesticide.id,
                pesticide: {
                    id: matchedPesticide.id,
                    pesticideResidueId: matchedPesticide.pesticideResidueId,
                    pesticideResidueName: matchedPesticide.pesticideResidueName
                }
            });
        } else {
            // Si pas trouvé, tout remettre à null
            this.pesticideControl.setValue(null);
            this.form.patchValue({ pesticideId: null, pesticide: { id: '', pesticideResidueId: '', pesticideResidueName: '' } });
        }
    } else {
        // Pour les molécules autres que pesticide
        this.pesticideControl.setValue(null);
        this.form.patchValue({ pesticideId: null, pesticide: { id: '', pesticideResidueId: '', pesticideResidueName: '' } });
    }

    // 3️⃣ Forcer la détection des changements et ouvrir la modal
    this.cdr.detectChanges();
    this.modalService.open(this.editModal, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'xl'
    });

    console.log("Formulaire après patch :", this.form.value);
}

    openViewModel(parameter: any) {
    console.log("Parameter sélectionnée :", parameter);

    if (this.form) {
        this.form.patchValue({
        id: parameter.id || null,
        codeParameter: parameter.codeParameter || '',
        sumVariants: parameter.sumVariants || '',
        name: parameter.name || '',
        abbreviation: parameter.abbreviation || '',
        paramName: parameter.paramName || '',
        norme: parameter.norme || '',
        description: parameter.description || '',
        met: parameter.met || '',
        duree: parameter.duree || '',
        //arabicName: parameter.arabicName || '',
        sousTraite: parameter.sousTraite ?? false,
        unite: parameter.unite || '',
        uniteRap: parameter.uniteRap || '',
        niveauSouhaitablemin: parameter.niveauSouhaitablemin || null,
        niveauSouhaitablemax: parameter.niveauSouhaitablemax || null,
        mri: parameter.mri || null,
         // qc: parameter.qc || null,
        //method: parameter.method || '',
        technique: parameter.technique || '',
        nomFamille: parameter.nomFamille || '',
        creationDate: parameter.creationDate ? new Date(parameter.creationDate) : null,
        updateDate: parameter.updateDate ? new Date(parameter.updateDate) : null,
        formuleText: parameter.formuleText || 'Non renseigné',
        createdByName: parameter.createdByName || (parameter.createdBy ? parameter.createdBy.username : 'Non renseigné'),
        pesticide: parameter.pesticide || null,
        pesticideId: parameter.pesticideId // reset par défaut
        });

        // ✅ Trouver pesticide à partir du champ `parameter.pesticide.pesticideResidueName`
        const pesticideName = parameter.pesticide?.pesticideResidueName;

        if (pesticideName && this.allPesticides?.length) {
        const matchedPesticide = this.allPesticides.find(
            p => p.pesticideResidueName?.toLowerCase() === pesticideName.toLowerCase()
        );

        if (matchedPesticide) {
            // 🎯 Affectation dans le form
            this.pesticideControl.setValue(matchedPesticide.id); // affichage (si champ autocomplete lié)
            this.form.get('pesticideId')?.setValue(matchedPesticide.id); // pour enregistrement
        }
        }

        this.cdr.detectChanges();
        this.modalService.open(this.viewModal, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'xl'
        });
    }
    }

         
    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
        }
    }

    confirmDelete(element: any) {
        this.dialogService.open('Vous etes sur de supprimer ce parameter?', environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.deleteParameter(element.id);
                }
            });
    }

    deleteParameter(id: number) {
        console.log("Suppression de la parameter avec l'id:", id); 

        this.parameterService.deleteParameter(id).pipe(
            tap((response: any) => {
                if (response.status) {
                    this.removeTableRow(id);
                    this.dialogService.openSuceessAlert('Parameter supprimé avec succès' );
                }
            }),
            finalize(() => {
                this.dataSource.paginator = this.paginator;
            })
        ).subscribe();
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(sample => sample.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchVal = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = this.searchVal
    }

    handleSelection(sam: ParameterDTO) {
        this.selectedMatrices.has(sam) ? this.selectedMatrices.delete(sam) : this.selectedMatrices.add(sam)
    }
    handleSelectAll() {
        this.isAllParameterSelected = !this.isAllParameterSelected;
        
        if (this.isAllParameterSelected) {
            this.selectedMatrices = new Set<ParameterDTO>(this.dataSource.filteredData);
        } else {
            this.selectedMatrices = new Set<ParameterDTO>();
        }
    }
    
    openModal(content: any) {
        this.form.reset()
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'xl'}).result.then(
            (result) => {
                if (result === 'save') {
                }
            }
        );
    }
saveParameter1() {
    console.log("=== Début de saveParameter ===");

    // 🔹 Récupérer l'utilisateur connecté depuis la session
    const currentUserIdStr = sessionStorage.getItem('user_id');
    if (!currentUserIdStr) {
        console.error("❌ Utilisateur non trouvé dans la session.");
        return;
    }
    const currentUserId = Number(currentUserIdStr);
    console.log("Utilisateur connecté ID:", currentUserId);

    // 🔹 Récupérer la formule sélectionnée (optionnelle)
    let formuleId: number | null = null;
    const formuleValue = this.form.get('formule')?.value;
    if (formuleValue) {
        formuleId = Number(formuleValue);
        console.log("Formule sélectionnée ID:", formuleId);
    } else {
        console.log("Aucune formule sélectionnée, champ optionnel");
    }

    // 🔹 Cloner et préparer le DTO à envoyer
    const newParameter: any = {
        codeParameter: this.form.get('codeParameter')?.value,
        sumVariants: this.form.get('sumVariants')?.value,
        paramName: this.form.get('paramName')?.value,
        abbreviation: this.form.get('abbreviation')?.value,
        norme: this.form.get('norme')?.value,
        description: this.form.get('description')?.value,
        met: this.form.get('met')?.value,
        duree: this.form.get('duree')?.value,
        nomFamille: this.selectedNomFamille,
        pesticideId: null,
        unite: this.form.get('unite')?.value,
        sousTraite: this.form.get('sousTraite')?.value ?? false,
        uniteRap: this.form.get('uniteRap')?.value,
        niveauSouhaitablemin: this.form.get('niveauSouhaitablemin')?.value,
        niveauSouhaitablemax: this.form.get('niveauSouhaitablemax')?.value,
        mri: this.form.get('mri')?.value,
         // qc: this.form.get('qc')?.value,
        technique: this.form.get('technique')?.value,
        departementId: this.form.get('departementId')?.value,
        createdById: currentUserId,
        formuleId: formuleId // 🔹 envoie null si pas de formule
    };

    // 🔹 Gestion du pesticide si c'est un parameter de type PESTICIDE
    if (this.selectedNomFamille === 'PESTICIDE') {
        const selectedPesticide = this.allPesticides.find(
            p => p.pesticideResidueId === Number(this.pesticideControl.value)
        );
        if (!selectedPesticide) {
            console.error("❌ Pesticide sélectionné non trouvé.");
            return;
        }
        newParameter.pesticideId = selectedPesticide.pesticideResidueId;
        console.log("✅ Pesticide associé ID:", newParameter.pesticideId);
    } else {
        console.log("✅ Cas molécule libre, pas de pesticide");
    }

    console.log("✅ DTO prêt à envoyer:", newParameter);

    // 🔹 Appel au backend
    this.parameterService.createParameter(newParameter).subscribe({
        next: (response) => {
            console.log("✅ Réponse du backend:", response);
            if (response.status) {
                console.log("✅ Parameter créée avec succès !");
                this.modalService.dismissAll();
                this.cdr.detectChanges();
                this.fetchSampleList();
            } else {
                console.error("❌ Échec de la création:", response.message);
                this.creatingParameter = false;
                this.modalService.dismissAll();
                this.cdr.detectChanges();
            }
        },
        error: (error) => {
            console.error("❌ Erreur lors de la création:", error);
            this.creatingParameter = false;
            this.modalService.dismissAll();
            this.cdr.detectChanges();
        }
    });
}


saveParameter() {
    console.log("=== Début de saveParameter ===");

    // 🔹 Récupérer l'utilisateur connecté depuis la session
    const currentUserIdStr = sessionStorage.getItem('user_id');
    if (!currentUserIdStr) {
        console.error("❌ Utilisateur non trouvé dans la session.");
        return;
    }
    const currentUserId = Number(currentUserIdStr);
    console.log("Utilisateur connecté ID:", currentUserId);

    // 🔹 Récupérer la formule sélectionnée (optionnelle)
    let formuleId: number | null = null;
    const formuleValue = this.form.get('formule')?.value;
    if (formuleValue) {
        formuleId = Number(formuleValue);
        console.log("Formule sélectionnée ID:", formuleId);
    } else {
        console.log("Aucune formule sélectionnée, champ optionnel");
    }

    // 🔹 Cloner et préparer le DTO à envoyer
    const newParameter: any = {
        codeParameter: this.form.get('codeParameter')?.value,
        sumVariants: this.form.get('sumVariants')?.value,
        paramName: this.form.get('paramName')?.value,
        abbreviation: this.form.get('abbreviation')?.value,
        norme: this.form.get('norme')?.value,
        description: this.form.get('description')?.value,
        met: this.form.get('met')?.value,
        duree: this.form.get('duree')?.value,
        nomFamille: this.selectedNomFamille,
        pesticideId: null,
        pesticideResidueName: null, // 🔹 Ajouter le nom du résidu
        unite: this.form.get('unite')?.value,
        sousTraite: this.form.get('sousTraite')?.value ?? false,
        uniteRap: this.form.get('uniteRap')?.value,
        niveauSouhaitablemin: this.form.get('niveauSouhaitablemin')?.value,
        niveauSouhaitablemax: this.form.get('niveauSouhaitablemax')?.value,
        mri: this.form.get('mri')?.value,
         // qc: this.form.get('qc')?.value,
        technique: this.form.get('technique')?.value,
        departementId: this.form.get('departementId')?.value,
        createdById: currentUserId,
        formuleId: formuleId
    };

    // 🔹 Gestion du pesticide si c'est un parameter de type PESTICIDE
    if (this.selectedNomFamille === 'PESTICIDE') {
        console.log("🔹 Nom famille est PESTICIDE");

        console.log("Valeur du pesticideControl.value:", this.pesticideControl.value);
        console.log("Liste de tous les pesticides disponibles:", this.allPesticides);

        // 🔹 Chercher le pesticide sélectionné par son ID primaire
        const selectedPesticide = this.allPesticides.find(
            p => Number(p.id) === Number(this.pesticideControl.value)
        );

        if (!selectedPesticide) {
            console.error("❌ Pesticide sélectionné non trouvé !");
            console.error("🔹 Valeur du select:", this.pesticideControl.value);
            console.error("🔹 Vérifie si pesticide existe dans allPesticides");
            return;
        }

        // 🔹 Ici on envoie l'ID primaire
        newParameter.pesticideId = selectedPesticide.id;
        newParameter.pesticideResidueName = selectedPesticide.pesticideResidueName;

        console.log("✅ Pesticide associé ID (primary key):", newParameter.pesticideId);
        console.log("✅ Pesticide associé Name:", newParameter.pesticideResidueName);
    } else {
        console.log("✅ Cas molécule libre, pas de pesticide");
    }

    console.log("✅ DTO prêt à envoyer:", newParameter);

    // 🔹 Appel au backend pour créer le parameter
    this.parameterService.createParameter(newParameter).subscribe({
        next: (response) => {
            console.log("✅ Réponse du backend:", response);
            if (response.status) {
                console.log("✅ Parameter créée avec succès !");
                this.modalService.dismissAll();
                this.cdr.detectChanges();
                this.fetchSampleList();
            } else {
                console.error("❌ Échec de la création:", response.message);
                this.creatingParameter = false;
                this.modalService.dismissAll();
                this.cdr.detectChanges();
            }
        },
        error: (error) => {
            console.error("❌ Erreur lors de la création:", error);
            this.creatingParameter = false;
            this.modalService.dismissAll();
            this.cdr.detectChanges();
        }
    });
}


    public fetchSampleList() {
        this.parameterService.getAllParameters().subscribe({
            next: response => {
            console.log("Réponse API:", response); 
            if (response.status) {  
                this.dataSource.data = response.data;  
            }
            this.loadingTable = false;
    },
    error: err => {
        this.handleErrors.catchError(err);
        this.loadingTable = false;
    }
});
  }

    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return ['select', ...this.displayedColumns, 'action']
    };

    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`sampleCol_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }
private getColsCookie() {
    const sampleCols = this.cookieService.get(`sampleCol_${this.user_name}`);
    if (sampleCols) {
        this.displayedColumns = JSON.parse(sampleCols);
        console.log('Retrieved columns:', this.displayedColumns);
        this.cdr.detectChanges(); // <-- FORCER le rerender de la table
    }
}
    openImportModal(importModal: any) {
        this.modalService.open(importModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'})
    }
}
